var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 116,
    viewBox: "0 0 150 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 0.5H6C4.47501 0.5 3.01247 1.1058 1.93414 2.18414C0.855802 3.26247 0.25 4.72501 0.25 6.25V104C0.25 107.05 1.4616 109.975 3.61827 112.132C5.77494 114.288 8.70001 115.5 11.75 115.5H138.25C141.3 115.5 144.225 114.288 146.382 112.132C148.538 109.975 149.75 107.05 149.75 104V6.25C149.75 4.72501 149.144 3.26247 148.066 2.18414C146.988 1.1058 145.525 0.5 144 0.5ZM53.9406 58L11.75 96.6688V19.3312L53.9406 58ZM62.4219 65.8344L71.1188 73.7406C72.1787 74.7104 73.5633 75.2482 75 75.2482C76.4367 75.2482 77.8213 74.7104 78.8812 73.7406L87.5781 65.8344L129.194 104H20.8062L62.4219 65.8344ZM96.0594 58L138.25 19.3312V96.6688L96.0594 58Z",
    fill: "#47B881"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.0fefae9d.svg";
export { ForwardRef as ReactComponent };